import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = '1em',
  borderRadius = '4px',
  className = '',
}) => {
  return (
    <div
      className={`skeleton ${className}`}
      style={{ width, height, borderRadius }}
    />
  );
};

export const SkeletonCard: React.FC = () => {
  return (
    <article className="skeleton-card">
      <header className="skeleton-card__header">
        <Skeleton width="60%" height="24px" borderRadius="8px" />
        <Skeleton width="48px" height="48px" borderRadius="10px" />
      </header>
      <Skeleton width="80%" height="16px" borderRadius="4px" className="skeleton-card__line" />
      <Skeleton width="50%" height="16px" borderRadius="4px" className="skeleton-card__line" />
      <div className="skeleton-card__footer">
        <Skeleton width="70%" height="48px" borderRadius="10px" />
        <Skeleton width="48px" height="48px" borderRadius="10px" />
      </div>
    </article>
  );
};
